import { render } from "./AttendanceSettingLayout.vue?vue&type=template&id=5ee1fbf2"
import script from "./AttendanceSettingLayout.vue?vue&type=script&lang=js"
export * from "./AttendanceSettingLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__